/**
 * TransferStatusBadge — the single status capsule for OUTPUT / TRANSFER ids.
 * One source of truth for the colors + i18n (warehouseTransfer.*), shared by the Transfers page
 * (WarehouseTransferManagement) and the Production Summary header (DailyTransferOutView). Covers the
 * transfer/output lifecycle: draft → pending → scanned → complete (+ cancelled). NOT statusColors.ts
 * (that one is for session statuses and lacks draft/scanned).
 */
import { useLanguage } from '../i18n/LanguageContext';

const STYLES: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  scanned: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-300',
  complete: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  cancelled: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
};

export function TransferStatusBadge({ status, small = false }: { status?: string; small?: boolean }) {
  const { t } = useLanguage();
  const s = status || 'draft';
  return (
    <span className={`inline-block rounded-full font-medium ${small ? 'px-1.5 py-0 text-[9px] leading-[14px]' : 'px-2 py-1 text-xs'} ${STYLES[s] || STYLES.draft}`}>
      {t(`warehouseTransfer.${s}`)}
    </span>
  );
}

export default TransferStatusBadge;
